import { z } from 'zod';
/**
 * Attack intent: "I want to fight this mob". The server walks the player into
 * range, paces the hits and rolls the damage; the client never sends a result.
 */
export const AttackMessageSchema = z.object({
    /** Mob id in the zone state, e.g. `rat-3`. */
    targetId: z.string().min(1).max(64),
});
/** One landed hit, told to the clients so they can flash the target and float the number. */
export const HitEventSchema = z.object({
    target: z.enum(['mob', 'player']),
    /** Mob id, or the player's session id. */
    id: z.string().min(1),
    amount: z.number().int().min(0),
    hp: z.number().int().min(0),
    /** A critical hit (ADR 0049): the number rises bigger and in gold. */
    crit: z.boolean().optional(),
    /** The striker's session id, on a player's blow: their own crit shakes their screen. */
    by: z.string().min(1).optional(),
});
/**
 * A monster shot at a player (ADR 0055): the client flies the projectile
 * from the mob to the player for `ms`, homing on them as they move. The
 * damage arrives on its own as a `hit` when it lands; this is only the look.
 */
export const MobShotEventSchema = z
    .object({
    mobId: z.string().min(1),
    /** The target's session id. */
    target: z.string().min(1),
    ms: z.number().int().positive(),
})
    .strict();
/**
 * A monster has just picked this player as its prey: the client pops a red
 * « ! » over its head. Sent to the prey alone, only when the chase begins or
 * turns to them, never while it goes on.
 */
export const MobAggroEventSchema = z
    .object({
    mobId: z.string().min(1),
})
    .strict();
//# sourceMappingURL=attack.js.map